import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import ForgotPasswordSuccessModal from '../../components/login/forgot-password-success'

const mapStateToProps = (state) => ({
  email: state.auth.email || 'your email',
})

const mapDispatchToProps = (dispatch, newProps) => ({
  handleClose () {
    dispatch(replace('/login'))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordSuccessModal)



// WEBPACK FOOTER //
// ./src/containers/login/forgot-password-success-container.js